import { motion } from 'framer-motion';
import { PawPrint } from 'lucide-react';

const PetCareSection = ({ onReserveClick }) => {
  return (
    <section className="pt-3 pb-5 md:pt-4 md:pb-6" data-testid="pet-care-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mx-auto"
        >
          <div className="bg-gradient-to-br from-[#FAF8F5] to-[#F5F0EA] rounded-2xl border border-black/6 
                          shadow-sm p-5 md:p-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-white border border-black/5 shadow-sm 
                              flex items-center justify-center flex-shrink-0">
                <PawPrint className="w-5 h-5 text-[#8B7355]" />
              </div>

              {/* Content */}
              <div className="flex-1">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <div>
                    <h3 className="text-base md:text-lg font-semibold text-[#1A1A1A] mb-0.5">
                      Pet Care Add-On
                    </h3>
                    <p className="text-xs text-[#5A5A5A] italic mb-1">
                      Because they're family too.
                    </p>
                    <p className="text-xs text-[#6A6A6A] leading-relaxed max-w-md">
                      Add a Connect Pet band to monitor activity, movement patterns, and location (if enabled) — all inside the same Connect app.
                    </p>
                  </div>

                  {/* Price & CTA */}
                  <div className="flex flex-col items-start sm:items-end gap-1.5 flex-shrink-0">
                    <div className="text-right">
                      <div className="text-xl font-semibold text-[#1A1A1A]">$49</div>
                      <p className="text-xs text-[#7A7A7A]">per pet band</p>
                    </div>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={onReserveClick}
                      className="bg-[#1A1A1A] text-white px-4 py-1.5 rounded-full text-xs font-medium
                                 hover:bg-[#333] transition-all duration-300"
                      data-testid="pet-care-add-btn"
                    >
                      Add Pet Band
                    </motion.button>
                    <p className="text-xs text-[#8A8A8A]">Works with any Connect plan.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PetCareSection;
